const createCollectionValidator = (collection) => {
  if (!collection?.name) throw new Error('Name is required');
  if (!collection?.company_ids?.length) throw new Error('Select companies');
};

export default createCollectionValidator;
